var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.msg.length>0)?_c('div',{class:_vm.classArr},[_vm._v(" "+_vm._s(_vm.msgShow)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }